import { FormattedMessage } from 'react-intl';
import React from 'react';
import { BATCHES_PROCESSED_VIEW_ID, BATCHES_VIEW_ID } from './view-id-constants';

export const BatchesProcessed = {
  label: <FormattedMessage defaultMessage='Processed' description='ordersPage.nav.processedBatches' id='W6F8Gz' />,
  id: BATCHES_PROCESSED_VIEW_ID,
  navigationOverride: '/shipments/batches/processed',
  parentId: BATCHES_VIEW_ID,
};
